import { DepotAudit } from "./components/DepotAudit";

export default DepotAudit;